<template>
  <div
    :class="{ 'preview-playbar' : toggle }"
    class="player-bar">
    <div class="control">
      <img
        class="play-button"
        :src="`/img/vector/${ buttonImage }`"
        @click.prevent="togglePlay" />
    </div>
    <div
      class="start-btn">
      <a
        href="#"
        @click.prevent="onStartFromBegin">
        <img src="/img/vector/icon-back.svg">
      </a>
    </div>
    <div
      class="five-rewind">
      <a
        href="#"
        @click.prevent="onRewind5s">
        <img src="/img/vector/icon-five-back.svg">
      </a>
    </div>
    <div
      class="five-back">
      <a
        href="#"
        @click.prevent="onForward5s">
        <img src="/img/vector/icon-five-front.svg">
      </a>
    </div>
    <div
      :class="{ 'btn-off': toggle }"
      class="five-back ">
      <a
        href="#"
        :class="{'btn-off': playing}"
        @click.prevent="onReset">
        <img src="/img/vector/icon-reset.svg">
      </a>
    </div>
    <div class="time">
      {{ currentTimeString }} / {{ msToTime(durationString) }}
    </div>
    <div class="seekbar">
      <vue-slider
        v-model="position"
        :process-style="{ 'background-color': '#fff' }"
        tooltip="none"
        @change="onPositionChanged" />
    </div>
    <div class="preview">
      <div class="on-off">
        <span>プレビュー</span>
        <label class="switch">
          <input
            v-model="toggle"
            type="checkbox"
            @click="onPreviewClicked">
          <span class="slider round"></span>
        </label>
      </div>
      <div class="time-forward-back">
        <span>再生速度</span>
        <div class="play-speed">
          <button
            type="button"
            class="play-speed-button"
            @click.prevent="onRateClicked">
            {{ speedRatelabel === '' ? '通常' : speedRatelabel }}
          </button>
          <div
            v-show="showRateSelect"
            class="play-speed-list">
            <div
              class="play-speed-item"
              rate="0.25"
              @click.prevent="onSelectedRate">
              ×0.25
            </div>
            <div
              class="play-speed-item"
              rate="0.50"
              @click.prevent="onSelectedRate">
              ×0.50
            </div>
            <div
              class="play-speed-item"
              rate="0.75"
              @click.prevent="onSelectedRate">
              ×0.75
            </div>
            <div
              class="play-speed-item"
              rate="1.00"
              @click.prevent="onSelectedRate">
              通常
            </div>
            <div
              class="play-speed-item"
              rate="1.25"
              @click.prevent="onSelectedRate">
              ×1.25
            </div>
            <div
              class="play-speed-item"
              rate="1.50"
              @click.prevent="onSelectedRate">
              ×1.50
            </div>
            <div
              class="play-speed-item"
              rate="2.00"
              @click.prevent="onSelectedRate">
              ×2.00
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Howl } from 'howler'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'
import { getPreSignedUrl } from '../../logic/url'

export default {
  name: 'SyncAudioPlayer',

  components: {
    VueSlider,
  },
  props: {
    url: {
      type: String,
      required: false,
      default: '',
    },
    durationString: {
      type: Number,
      required: false,
      default: 0,
    },
    currentPlayUrl: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
      duration: 0,
      currentTime: 0,
      playingSpeedRate: 1,
      showRateSelect: false,
      speedRatelabel: '',
      playing: false,
      loading: false,
      position: 0,
      audioPlayer: null,
      playTimer: null,
      toggle: false,
    }
  },
  computed: {
    currentTimeString() {
      const currentTime = Math.round(this.currentTime * 1000)
      return this.msToTime(currentTime)
    },
    buttonImage() {
      if (this.loading) return 'spinner.gif'
      if (this.playing) return 'icon-pause.svg'
      return 'icon-play.svg'
    },
  },
  watch: {
    url() {
      if (this.url && this.audioPlayer) {
        this.audioPlayer.pause()
      }
    },
    currentPlayUrl() {
      if (this.audioPlayer && this.url !== this.currentPlayUrl) {
        this.audioPlayer.pause()
      }
    },
    playingSpeedRate() {
      if (this.audioPlayer) {
        this.audioPlayer.rate(this.playingSpeedRate)
      }
    },
  },
  destroyed() {
    if (this.playTimer) {
      clearTimeout(this.playTimer)
    }
    if (this.audioPlayer) {
      this.audioPlayer.pause()
      this.audioPlayer = null
    }
  },
  mounted() {
  },
  methods: {
    updateTimer() {
      if (!this.audioPlayer) {
        this.togglePlay()
        return
      }
      this.duration = this.audioPlayer.duration()
      this.currentTime = this.audioPlayer.seek()
      if (this.toggle) {
        // update preview current time while previewMode
        this.$emit('timeupdate', this.currentTime)
      }
      const position = (this.currentTime / this.duration) * 100
      this.position = !Number.isNaN(position) ? position : 0
    },
    async togglePlay() {
      if (this.playTimer) {
        clearTimeout(this.playTimer)
      }
      if (this.playing) {
        this.audioPlayer.pause()
      } else if (!this.audioPlayer) {
        this.loading = true

        const audioUrl = await getPreSignedUrl(this.url)
        this.audioPlayer = new Howl({
          src: [audioUrl],
          html5: true,
        })

        this.audioPlayer.once('load', () => {
          if (this.position > 0) {
            this.audioPlayer.seek(this.currentTime)
          }
          this.audioPlayer.play()
          this.audioPlayer.rate(this.playingSpeedRate)
          this.loading = false
        })
        this.audioPlayer.on('play', () => {
          this.playing = true
          this.playTimer = setInterval(this.updateTimer, 100)
        })
        this.audioPlayer.on('pause', () => {
          this.playing = false
        })
        this.audioPlayer.on('end', () => {
          clearInterval(this.playTimer)
          setTimeout(() => {
            this.playing = false
            this.currentTime = 0
            this.position = 0
          }, 700)
        })
        this.$emit('play-start', this.url, this.audioPlayer, this.currentTime)
      } else {
        this.audioPlayer.play()
        this.audioPlayer.rate(this.playingSpeedRate)
        this.$emit('play-start', this.url, this.audioPlayer, this.currentTime)
      }
    },
    onPositionChanged(position) {
      if (this.audioPlayer && this.playing) {
        // this.togglePlay()
        this.audioPlayer.seek(this.audioPlayer.duration() * (position / 100))
        return
      }
      this.currentTime = (this.durationString * (position / 100)) / 1000
      // update preview current time while previewMode
      if (this.toggle) {
        // update preview current time while previewMode
        this.$emit('timeupdate', this.currentTime)
      }
    },
    onStartFromBegin() {
      if (this.url && this.audioPlayer && this.playing) {
        this.audioPlayer.seek(0)
      } else {
        this.currentTime = 0
        this.position = 0
        // update preview current time while previewMode
        if (this.toggle) {
          // update preview current time while previewMode
          this.$emit('timeupdate', this.currentTime)
        }
      }
    },
    onForward5s() {
      if (this.url && this.audioPlayer && this.playing) {
        this.audioPlayer.seek(this.audioPlayer.seek() + 5)
      } else {
        this.currentTime += 5
        const duration = this.durationString / 1000
        const position = (this.currentTime / duration) * 100
        this.position = !Number.isNaN(position) ? position : 0
        // update preview current time while previewMode
        if (this.toggle) {
          // update preview current time while previewMode
          this.$emit('timeupdate', this.currentTime)
        }
      }
    },
    onRewind5s() {
      if (this.url && this.audioPlayer && this.playing) {
        this.audioPlayer.seek(this.audioPlayer.seek() - 5)
      } else if (this.currentTime >= 5) {
        this.currentTime -= 5
        const duration = this.durationString / 1000
        const position = (this.currentTime / duration) * 100
        this.position = !Number.isNaN(position) ? position : 0
        // update preview current time while previewMode
        if (this.toggle) {
          // update preview current time while previewMode
          this.$emit('timeupdate', this.currentTime)
        }
      }
    },
    onPreviewClicked() {
      this.$emit('previewMode', !this.toggle)
    },
    onReset() {
      this.$parent.onResetLyricsTime()
      this.$parent.$refs.timeBar.scroll(0, 0)
    },
    onRateClicked() {
      this.showRateSelect = true
    },
    onSelectedRate(event) {
      this.showRateSelect = false
      this.speedRatelabel = event.currentTarget.innerText
      this.playingSpeedRate = Number(event.target.getAttribute('rate'))
    },
    msToTime(duration) {
      const hour = Math.floor(duration / 3600000)
      const minute = Math.floor((duration - 3600000 * hour) / 60000)
      const mm = (`00${minute}`).slice(-2)
      const ms = (`00000${duration % 60000}`).slice(-5)
      const time = `${mm}:${ms.slice(0, 2)}.${ms.slice(2, 5)}`
      return time
    },
  },
}
</script>

<style scoped>
.player-bar {
  display: flex;
  width: 100%;
  height: 100%;
  align-items: center;
  flex-direction: row;
  justify-content: flex-end;
}
.control {
}
.seekbar {
  flex-grow: 1;
  margin-left: 8px;
  margin-right: 8px;
  margin-top: 3px;
}
.time {
  font-family: monospace, monospace;
  margin-right: 8px;
  color: #fff;
  font-size: 14px;
  margin-top: 5px
}
.play-button {
  width: 22px;
  height: 22px;
  cursor: pointer;
  margin: 5px;
}
.play-speed {
    position: relative;
}

.play-speed-list {
  background: #fff;
  color: #444;
  position: absolute;
  top: 27px;
  left: -19px;
  width: 90px;
  box-shadow: 0 0 5px #b1b1b1;

}
.play-speed-item:hover {
  background: #e9e7e7;
  cursor: pointer;
}

.play-speed-item {
  padding: 9px 0 5px 0;
}

button.play-speed-button {
  position: relative;
  width: 54px;
  color: #444;
}

button.play-speed-button:focus {
  background: #fff;
}

.vue-slider-dot-handle {
  background-color: #f8a104 !important;
}
.preview .time-forward-back {
  align-self: end;
  display: flex;
  gap: 10px;
}
.preview .time-forward-back span {
  font-size: 14px;
  line-height: 26px;
}

.player-bar .preview {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.player-bar.preview-playbar {
  background: #282c34;
  opacity: 0.9;
}
</style>
